import { memo, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BuyButton from './BuyButton';
import RemoveButton from './RemoveButton';
import { faApple, faWindows } from '@fortawesome/free-brands-svg-icons';
import {
  faArrowRight,
  faCheck,
  faShoppingCart
} from '@fortawesome/free-solid-svg-icons';

const BuyNowBtnText = memo(({ isAddedToCart, children, icon }) => {
  if (isAddedToCart) {
    return (
      <>
        <FontAwesomeIcon
          icon={faShoppingCart}
          className="mr-2"
          />
        To checkout
        <FontAwesomeIcon
          icon={faArrowRight}
          className="ml-2"
          />
      </>
    )
  }

  return (
    <>
      <FontAwesomeIcon
        icon={icon === 'mac' ? faApple : icon === 'pc' ? faWindows : faShoppingCart}
        className="mr-2"
      />
      {icon === 'mac' ? 'Buy for Mac' : icon === 'pc' ? 'Buy for PC' : icon === 'buynow' ? 'Buy Now' : 'Add to cart'}
    </>
  )
})

export default memo(({fastspringId, children = 'Add to cart', onClick, icon, ...props}) => {
  const addedToCartAddon = useMemo(() => {
    return (
      <small className="mt-3 mb-3 d-block text-muted text-center">
          <span className="mr-2">
            <FontAwesomeIcon
              icon={faCheck}
              className="mr-2"
            />
            Added to cart
          </span>
        <RemoveButton
          productId={fastspringId}
          onClick={onClick}
        />
      </small>
    )
  }, [onClick, fastspringId])

  return (
    <BuyButton
      productId={fastspringId}
      onClick={onClick}
      addedToCartAddon={addedToCartAddon}
      className=''
      {...props}
    >
      <BuyNowBtnText icon={icon}>
        {children}
      </BuyNowBtnText>
    </BuyButton>
  )

})
